module.exports = __webpack_public_path__ + "img/health_wealth.c9919bc9.png";